import React from 'react';
import { getBillingUrl, goLogin } from "../../../../common/utils/passUtil";

export default function PointBox(props) {
  return (
    <>
      {
        props.data && props.data.map((item, index) => {
          const billingUrl = getBillingUrl(props.loginJwt, 'mobile', props.group == 'pass' ? 'free_point' : 'point', item.product_id)

          return (
            <div key={`point-box-${index}`} className={`pointModule_type${props.type}`}>
              {item.label && (<span className={`moduleLabel-${item.label.type}`}>{item.label.text}</span>)}
              <a
                href="#"
                className="pointModuleLink"
                onClick={(e) => {
                  e.preventDefault();
                  if (props.loginJwt) {
                    window.location.href = billingUrl;
                  } else {
                    window.location.href = goLogin();
                  }
                }}
              >
                <div className="pointModuleSubTitle">{item.product_name}</div>
                <div className="pointModuleCont">
                  <strong className="pointModuleTitle">{item.display_price}</strong>
                  <em className="pointModuleNumber">{item.price}</em>
                </div>
                <strong className="pointModule_noticeTitle">{props.lang === 'en' ? 'Coupon Notes' : '쿠폰 유의사항'}</strong>
                <ul className="pointModule_noticeList">
                  <li className="pointModule_noticeText">{props.lang === 'en' ? 'The period of use is one year from purchase.' : <>사용 기간은 구매 후&nbsp;1년입니다.</>}</li>
                  <li className="pointModule_noticeText">{props.lang === 'en' ? 'When you click on Purchase Ticket after purchase, it will be registered in the coupon list.' : <>구매 후 이용권 구매 클릭 시&nbsp;쿠폰 리스트에&nbsp;등록됩니다.</>}</li>
                  <li className="pointModule_noticeText">{props.lang === 'en' ? 'S Points used are non-refundable.' : '사용하신 S포인트는 환불 불가합니다.'}</li>
                </ul>
              </a>
            </div>
          )
        })
      }
    </>
  );
}
